import styled from 'styled-components';
import { GhostClientListItem } from '../GhostComponents/GhostClientListItem';
import { ButtonLink } from '../Button';
import { Text } from '../Text';
import UploadToCloudIcon from '@/icons/UploadToCloud';
import DocumentIcon from '@shared/components/icons/Document';

type Props = {
    className?: string;
};

function UnstyledEmptyHomeDashboardCallouts({ className }: Props): JSX.Element {
    return (
        <div className={className}>
            <GhostClientListItem />
            <GhostClientListItem />
            <GhostClientListItem />
            <GhostClientListItem />
            <GhostClientListItem />

            <EmptyClientsAreaCalloutWrapper>
                <GetStartedCallout>
                    <IconWrapper>
                        <UploadToCloudIcon
                            width={28}
                            height={30}
                            strokeColor="uNavy"
                        />
                    </IconWrapper>

                    <Text as="h4" weight="bold" size="large" color="uNavy">
                        Import individual client portfolios
                    </Text>

                    <ButtonLink
                        to="/client/create"
                        prefetch="intent"
                        $variant="lineIcon"
                        size="small"
                        style={{ marginTop: 'auto', alignSelf: 'flex-start' }}
                    >
                        Create client
                    </ButtonLink>
                </GetStartedCallout>

                <GetStartedCallout>
                    <IconWrapper>
                        <DocumentIcon
                            width={28}
                            height={30}
                            fillColor="uNavy"
                        />
                    </IconWrapper>

                    <Text as="h4" weight="bold" size="large" color="uNavy">
                        Upload firm wide portfolios
                    </Text>

                    <ButtonLink
                        to="/settings/organisation"
                        prefetch="intent"
                        $variant="lineIcon"
                        size="small"
                        style={{ marginTop: 'auto', alignSelf: 'flex-start' }}
                    >
                        Add approved propositions
                    </ButtonLink>
                </GetStartedCallout>
            </EmptyClientsAreaCalloutWrapper>
        </div>
    );
}

export const EmptyHomeDashboardCallouts = styled(
    UnstyledEmptyHomeDashboardCallouts
)`
    padding: 30px 0px;
    position: relative;

    ${GhostClientListItem} {
        margin-bottom: ${({ theme }) => theme.spacing.medium};
        opacity: 0.5;
    }
`;

const EmptyClientsAreaCalloutWrapper = styled.div`
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 16px;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;

    & > * {
        flex: 1;
    }
`;

const GetStartedCallout = styled.div`
    background-color: ${({ theme }) => theme.colors.white};
    padding: 22px;
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 24px;
    max-width: 330px;
    height: 250px;
`;

const IconWrapper = styled.div`
    background: ${({ theme }) => theme.colors.uLightNavy};
    border-radius: 3px;
    padding: 12px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    z-index: 2;
`;
